<template>
  <div>
    <com-table
      ref="table"
      :columns="columns"
      :api="api"
      :defaultParams="defaultParams"
      :selection="isShowCheck"
      :defaultSelect="selectedList"
      @selection-change="handleSelectionChange"
    >
      <template #operation="row">
        <el-button
          type="primary"
          size="mini"
          @click="handleAudit(row.data)"
          v-if="row.data.auditStatus === 0"
          >审核</el-button
        >
        <el-button
          type="warning"
          size="mini"
          @click="handleRepair(row.data)"
          v-if="row.data.canRepair"
          >修复</el-button
        >
        <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
      </template>
      <template #type="row">
        {{ row.data.type === 1 ? '管理端提现' : row.data.type === 2 ? '用户申请提现' : '' }}
      </template>
      <template #createTime="row">
        {{ row.data.createTime | timeFormate }}
      </template>
      <template #auditTime="row">
        <div v-if="row.data.auditTime">
          {{ row.data.auditTime | timeFormate }}
        </div>
      </template>
      <template #auditStatus="row">
        {{ auditStatus[row.data.auditStatus] }}
      </template>
      <template #refundStatus="row">
        {{ refundStatus[row.data.refundStatus] }}
      </template>
    </com-table>
  </div>
</template>

<script>
import { userWithdrawalListApi } from '@/api/finance'
import { exportExcel } from '@/utils/index'
import { timeFormate } from '@/filters'

export default {
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    },

    isShowCheck: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: userWithdrawalListApi,
      auditStatus: {
        0: '待审核',
        1: '通过',
        2: '不通过'
      },
      refundStatus: {
        0: '退款中',
        1: '退款成功',
        2: '退款失败'
      },
      columns: [
        {
          label: '订单编号',
          prop: 'number',
          width: '160'
        },
        {
          label: '微信批次编号',
          prop: 'wxBatchId',
          width: '220'
        },
        {
          label: '提现金额',
          prop: 'amount',
          width: '100'
        },
        {
          label: '申请前充值金额',
          prop: 'beforeChargeSum',
          width: '100'
        },
        {
          label: '申请前赠送金额',
          prop: 'beforeGiveSum',
          width: '100'
        },
        // {
        //   label: '冻结充值金',
        //   prop: 'userFreeze',
        //   width: '120'
        // },
        // {
        //   label: '冻结赠送金',
        //   prop: 'userFreezeGiveSum',
        //   width: '120'
        // },
        {
          label: '应到账金额',
          prop: 'reviceSum',
          width: '100'
        },
        {
          label: '已退款金额',
          prop: 'successRefundPrice',
          width: '100'
        },
        {
          label: '剩余待退款金额',
          prop: 'surplusRefundPrice',
          width: '120'
        },
        {
          label: '退款进度',
          prop: 'refundProgressText',
          width: '120'
        },
        {
          label: '用户ID',
          prop: 'refUserNumber',
          width: '150'
        },
        {
          label: '联系电话',
          prop: 'refUserPhone',
          width: '150'
        },
        {
          label: '网点',
          prop: 'refUserRegisterStoreName',
          width: '150'
        },
        {
          label: '提现时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '120',
        },
        {
          label: '提现类型',
          prop: 'type',
          type: 'slot',
          slotName: 'type',
          width: '120'
        },
        {
          label: '审核状态',
          prop: 'auditStatus',
          type: 'slot',
          slotName: 'auditStatus',
          width: '100'
        },
        {
          label: '操作人',
          prop: 'refOperatorName',
          width: '100'
        },
        {
          label: '审核时间',
          prop: 'auditTime',
          type: 'slot',
          slotName: 'auditTime',
          width: '180'
        },
        {
          label: '提现原因',
          prop: 'applyReason',
          width: '150'
        },
        {
          label: '退款状态',
          prop: 'refundStatus',
          type: 'slot',
          slotName: 'refundStatus',
          width: '100'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          width: '240'
        }
      ],

      selectedList: [],
      exportQuery: {},
    }
  },
  methods: {
    handleDetail(row) {
      const params = {
        type: 'detail',
        row
      }
      this.$emit('detail', params)
    },
    handleRepair(row) {
      const params = {
        row
      }
      this.$emit('repair', params)
    },
    handleAudit(row) {
      const params = {
        type: 'audit',
        row
      }
      this.$emit('audit', params)
    },
    handleBatchAudit(row) {
      const params = {
        type: 'batch',
        row
      }
      this.$emit('audit', params)
    },
    update() {
      this.$refs.table.getList()
    },

    init() {
      this.selectedList = []
      this.$refs.table.clearSelection()
      this.$refs.table.init()
    },

    search(val) {
      this.exportQuery = val
      this.$refs.table.search(val)
    },

    handleSelectionChange(e) {
      const arr = []

      e.forEach((item) => {
        const param = {
          refStore: item.code,
          name: item.name
        }
        arr.push(param)
      })
      this.selectedList = [...arr]
      console.log('this.selectedList :>> ', e)
    },

    getSelectedList() {
      return this.selectedList
    },

    handleExport() {
      try {
        this.$message.info('请稍等,正在导出...')
        const query = {
          ...this.exportQuery,
          auditStatus: this.defaultParams.auditStatus,
          pageIndex: 1,
          pageSize: 10000
        }
        userWithdrawalListApi(query).then((res) => {
          const { records } = res.data
          let newArr = []
          records.forEach((item) => {
            const params = {
              订单编号: item.number,
              提现金额: item.amount,
              应到账金额: item.reviceSum,
              已退款金额: item.successRefundPrice,
              剩余待退款金额: item.surplusRefundPrice,
              退款进度: item.refundProgressText,
              申请前充值金额: item.beforeChargeSum,
              申请前赠送金额: item.beforeGiveSum,
              用户ID: item.refUserNumber,
              联系电话: item.refUserPhone,
              网点: item.refUserRegisterStoreName,
              提现时间: timeFormate(item.createTime),
              提现类型: item.type === 1 ? '管理端提现' : item.type === 2 ? '用户申请提现' : '',
              审核状态: this.auditStatus[item.auditStatus],
              操作人: item.refOperatorName,
              审核时间: timeFormate(item.auditTime),
              提现原因: item.applyReason,
              退款状态: this.refundStatus[item.refundStatus],
            }
            newArr.push(params)
          })
          exportExcel(newArr, '用户提现列表')
        })
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
